import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const K = {
  ink: "#004058",
  mid: "#4A6B7C",
  lt: "#94A3B8",
  sur: "#FFFFFF",
  bg: "#F8FAFC",
  brd: "#E2E8F0",
  alt: "#F1F5F9",
  red: "#EF4444",
  grn: "#10B981",
  mp: "#009EE3",
  r: { s: 6, m: 10, p: 14, l: 20, xl: 24, xxl: 32 },
  sh: { 
    s: "0 1px 4px rgba(0,0,0,.05)", 
    m: "0 4px 16px rgba(0,0,0,.08)", 
    l: "0 12px 40px rgba(0,0,0,.11)", 
    xl: "0 24px 72px rgba(0,0,0,.16)" 
  }
};

export default function RefundPolicy() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ minHeight: "100vh", background: K.bg, fontFamily: "'Open Sans', sans-serif" }}>
      
      {/* Header Fixo */}
      <nav style={{
        background: "rgba(255,255,255,0.9)", backdropFilter: "blur(10px)", 
        borderBottom: `1px solid rgba(0,0,0,0.05)`, padding: "0 24px", height: 70, 
        display: "flex", alignItems: "center", justifyContent: "space-between", 
        position: "fixed", top: 0, left: 0, right: 0, zIndex: 50
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
          <span 
            style={{ fontFamily: "'Poppins', sans-serif", fontSize: 24, fontWeight: 800, color: K.ink, cursor: "pointer" }} 
            onClick={() => navigate("/")}
          >
            Eventos<span style={{ color: "#009EE3" }}>&</span>Encontros
          </span>
        </div>
        <button 
          onClick={() => navigate("/")}
          style={{
            background: K.alt, color: K.ink, border: "none", padding: "8px 16px", 
            borderRadius: K.r.m, fontWeight: 700, cursor: "pointer", fontSize: 13
          }}
        >
          Voltar para Início
        </button>
      </nav>

      {/* Hero Section */}
      <header style={{
        background: `linear-gradient(135deg, ${K.ink} 0%, #001f2b 100%)`,
        padding: "140px 24px 80px",
        color: "#fff",
        textAlign: "center"
      }}>
        <div className="fu" style={{ maxWidth: 700, margin: "0 auto" }}>
          <div style={{
            display: "inline-block", background: "rgba(255,255,255,0.1)", 
            padding: "6px 14px", borderRadius: 100, fontSize: 13, 
            fontWeight: 600, marginBottom: 20, letterSpacing: 1
          }}>
            DIREITOS DO CONSUMIDOR
          </div>
          <h1 style={{ fontFamily: "'Poppins', sans-serif", fontSize: "clamp(32px, 5vw, 48px)", fontWeight: 800, marginBottom: 24, lineHeight: 1.2 }}>
            Política de Devolução e Cancelamento
          </h1>
          <p style={{ fontSize: 18, opacity: 0.8, lineHeight: 1.6 }}>
            Transparência e segurança para você. Nossa política foi elaborada com base no Código de Defesa do Consumidor Brasileiro (Lei 8.078/90).
          </p>
        </div>
      </header>

      {/* Conteúdo */}
      <main style={{ maxWidth: 800, margin: "-40px auto 100px", padding: "0 24px", position: "relative", zIndex: 10 }}>
        
        <div className="fu2" style={{
          background: K.sur, borderRadius: K.r.xl, boxShadow: K.sh.l, padding: "40px clamp(20px, 5vw, 50px)"
        }}>
          
          <section style={{ marginBottom: 40 }}>
            <h2 style={{ fontFamily: "'Poppins', sans-serif", fontSize: 22, color: K.ink, marginBottom: 16, display: "flex", alignItems: "center", gap: 10 }}>
              <span style={{ fontSize: 28 }}>🛡️</span> 1. Direito de Arrependimento (Art. 49)
            </h2>
            <p style={{ color: K.mid, lineHeight: 1.8, fontSize: 15, marginBottom: 12 }}>
              De acordo com o Artigo 49 do Código de Defesa do Consumidor (CDC), você tem o direito de se arrepender da compra do seu ingresso no prazo de até <strong>7 (sete) dias corridos</strong>, contados a partir da data de efetivação da compra no nosso ambiente online.
            </p>
            <div style={{ background: K.alt, padding: 16, borderRadius: K.r.m, borderLeft: `4px solid ${K.ink}` }}>
              <p style={{ color: K.ink, fontSize: 14, fontWeight: 600 }}>
                Atenção à exceção do prazo do evento:
              </p>
              <p style={{ color: K.mid, fontSize: 14, marginTop: 8 }}>
                Para que o estorno seja processado, a solicitação de cancelamento deve ser feita, impreterivelmente, com até <strong>48 horas de antecedência</strong> do horário de início do evento. Não realizamos cancelamentos no dia do evento ou após a sua realização.
              </p>
            </div>
          </section>

          <section style={{ marginBottom: 40 }}>
            <h2 style={{ fontFamily: "'Poppins', sans-serif", fontSize: 22, color: K.ink, marginBottom: 16, display: "flex", alignItems: "center", gap: 10 }}>
              <span style={{ fontSize: 28 }}>💳</span> 2. Prazos e Meios de Reembolso
            </h2>
            <p style={{ color: K.mid, lineHeight: 1.8, fontSize: 15, marginBottom: 20 }}>
              O estorno do valor será processado de acordo com a forma de pagamento original escolhida no Mercado Pago:
            </p>
            
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: 20 }}>
              <div style={{ border: `1px solid ${K.brd}`, borderRadius: K.r.m, padding: 20 }}>
                <h3 style={{ fontSize: 16, color: K.ink, marginBottom: 8, display: "flex", alignItems: "center", gap: 6 }}>
                  <div style={{ width: 12, height: 12, background: K.grn, borderRadius: "50%" }}></div> Pagamento via PIX
                </h3>
                <p style={{ fontSize: 14, color: K.mid, lineHeight: 1.5 }}>
                  O valor será devolvido diretamente na conta bancária de origem. O prazo médio de processamento pelo Mercado Pago é de <strong>algumas horas até 1 dia útil</strong> após a aprovação do cancelamento.
                </p>
              </div>
              <div style={{ border: `1px solid ${K.brd}`, borderRadius: K.r.m, padding: 20 }}>
                <h3 style={{ fontSize: 16, color: K.ink, marginBottom: 8, display: "flex", alignItems: "center", gap: 6 }}>
                  <div style={{ width: 12, height: 12, background: "#F59E0B", borderRadius: "50%" }}></div> Cartão de Crédito
                </h3>
                <p style={{ fontSize: 14, color: K.mid, lineHeight: 1.5 }}>
                  O estorno é enviado para a operadora do cartão. O crédito poderá aparecer na sua fatura em até <strong>2 faturas subsequentes</strong> (prazo que varia de acordo com o banco emissor do seu cartão).
                </p>
              </div>
            </div>
          </section>

          <section style={{ marginBottom: 40 }}>
            <h2 style={{ fontFamily: "'Poppins', sans-serif", fontSize: 22, color: K.ink, marginBottom: 16, display: "flex", alignItems: "center", gap: 10 }}>
              <span style={{ fontSize: 28 }}>❌</span> 3. Transferência de Titularidade
            </h2>
            <p style={{ color: K.mid, lineHeight: 1.8, fontSize: 15 }}>
              Os ingressos são <strong>nominais e intransferíveis</strong> na portaria por motivos de segurança e para evitar fraudes (cambismo). Se você não puder comparecer, deverá solicitar o cancelamento dentro do prazo legal citado acima (48h antes do evento).
            </p>
          </section>

          <section>
            <h2 style={{ fontFamily: "'Poppins', sans-serif", fontSize: 22, color: K.ink, marginBottom: 16, display: "flex", alignItems: "center", gap: 10 }}>
              <span style={{ fontSize: 28 }}>📩</span> 4. Como solicitar o cancelamento?
            </h2>
            <p style={{ color: K.mid, lineHeight: 1.8, fontSize: 15, marginBottom: 16 }}>
              Para solicitar o cancelamento e reembolso, entre em contato diretamente com a organização do evento através do balão de Fale Conosco na página inicial, informando:
            </p>
            <ul style={{ color: K.mid, fontSize: 15, lineHeight: 1.8, paddingLeft: 20, marginBottom: 20 }}>
              <li>Seu nome completo e CPF.</li>
              <li>O nome do evento.</li>
              <li>O e-mail utilizado na compra.</li>
            </ul>
            <p style={{ color: K.mid, lineHeight: 1.8, fontSize: 15 }}>
              Nossa equipe do Eventos e Encontros fará a mediação tecnológica e a solicitação de estorno na plataforma financeira (Mercado Pago) imediatamente após a aprovação da organização do encontro.
            </p>
          </section>

        </div>
      </main>

    </div>
  );
}
